import React, { Component } from "react";
import { Accessor } from "IZOX/STATIC";
import { HStack, VStack, XInput, XScroll, XText } from "IZOX/_X";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import Markdown from "IZOX/BLOCKS/Libs/Markdown/Markdown";

/**
 * @augments {Component<Props, State>}
 */
class MarkdownTest extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      otext: ""
    };
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(MarkdownTest.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    if(this.timeout) clearTimeout(this.timeout);
    if(this.interval) clearInterval(this.interval);
    this.setState = (state, callback) => {
      return;
    };
  }

  shouldComponentUpdate(nextProps, nextState){
    let propIdentical = Accessor.IsIdentical(nextProps, this.props, Object.keys(MarkdownTest.defaultProps));
    let stateIdentical = Accessor.IsIdentical(nextState, this.state, null);
    if(propIdentical && stateIdentical){
      return false;
    }
    return true;
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _setTimeout = (func, delay) => {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(func, delay);
  }

  _setInterval = (func, interval) => {
    if(this.interval) clearInterval(this.interval);
    this.interval = setInterval(func, interval);
  }

  _setText = (text) => {
    this.setState({
      text: text
    });
  }

  render(){
    let {text} = this.state;
    return (
      <HStack p={30} fullHeight spacing={20}>
        <VStack width={"45%"} fullHeight p={10}>
          <XText>
            {"Please input markdown here:"}
          </XText>
          <XInput value={text} onChangeText={this._setText} fullHeight multilines p={10}/>
        </VStack>
        <VStack width={"45%"} fullHeight HAlign="[" p={10}>
          <XText textAlign="[">
            {"Preview:"}
          </XText>
          <XScroll bW={1} fullHeight p={10}>
            <Markdown style={{height: "100%"}}>
              {text}
            </Markdown>
          </XScroll>
        </VStack>
      </HStack>
    );
  }

}

export default MarkdownTest;
